<template>
  <v-row no-gutters align="center" :id="concatIdentifier('table-actions')">
    <slot name="prepend-search"/>
    <v-col cols="12" sm="" style="min-width: 200px;" >
      <v-text-field
        v-if="showSearch"
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        clearable
        class="mr-2 mb-n1"
        color="primary"
        style="min-width: 200px;"
        :id="concatIdentifier('table-search')"
      ></v-text-field>
      <slot name="search-replacement"/>
    </v-col>
    <v-col cols="auto">
      <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on }">
          <v-switch
            color="primary"
            small
            v-if="showDense"
            class="ml-5 mb-n4 mt-0"
            v-model="dense"
            v-on="on"
            :id="concatIdentifier('density-switch')"
          ></v-switch>
        </template>
        <span class="white--text subtitle-1">{{ $t("denseView") }}</span>
      </v-tooltip>
    </v-col>
    <slot name="custom-controls"></slot>
    <v-col cols="auto" v-for="action in actions" :key="action.actionName" >
      <Icon
        :dataTestId="`table-${action.text}`"
        :elementId="action.id"
        :class="concatIdentifier('table-action')"
        margin="mr-2"
        :small="false"
        :iconColor="action.iconColor"
        :icon="action.icon"
        :tooltipText="action.text"
        :disabled="action.disabled"
        :overrideClickable="action.overrideClickable"
        @icon-clicked="$emit(`table-action`, action.actionName)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { kebabCase } from 'lodash'
export default {
  name: 'TableActions',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    actions: {
      type: Array
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showDense: {
      type: Boolean,
      default: false
    },
    htmlIdentifier: {
      type: String,
      required: false,
      default: undefined
    }
  },

  watch: {
    dense (val) {
      this.$emit('dense-toggled', val)
    },
    search (val) {
      this.$emit('search', val)
    }
  },

  data: () => ({
    dense: true,
    search: ''
  }),

  methods: {
    concatIdentifier (string) {
      return string.concat(this.htmlIdentifier ? `-${kebabCase(this.htmlIdentifier)}` : '')
    }
  }
}
</script>
